import { RouteObject, useParams } from "react-router-dom";
import BillTemplateLanding from "./components/landing";
import BillTemplateDetail from "./components/detail/detail";

export interface BillTemplateV3Route extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: BillTemplateV3Route[];
}

export const billTemplateV3Routes: BillTemplateV3Route[] = [
  {
    path: "/bx/bill-setup/billtemplate",
    element: <BillTemplateLanding />,
  },
  {
    path: "/bx/bill-setup/billtemplate/detail/:id",
    element: <BillTemplateDetail />,
  },
];
